import { Box, Typography } from '@mui/material';
import NoResults from '../../assets/NoResults';

export const EmptyStateView = ({
  message = 'No Data Found',
  minHeight = 300
}: {
  message?: string;
  minHeight?: number;
}) => {
  return (
    <Box display='flex' flexDirection='column' alignItems='center' minHeight={minHeight}>
      <NoResults />
      <Typography color='secondary' marginTop={2}>
        {message}
      </Typography>
    </Box>
  );
};
